import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import ReleaseTableHead from '../../components/molecules/ReleaseTableHead';
import ReleaseTableBody from '../../components/molecules/ReleaseTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import { getShops } from '../../actions/Shop';
import { removeStripShopData } from '../../libs/apis/ShopApi';

const styles = {
  scrollTable: {
    // maxHeight: 346,
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops,
      totalCount: state.shops.totalCount,
      offset: state.shops.offset
    }),
    dispatch => ({
      actions: bindActionCreators({ getShops }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('loading', 'updateLoading', false),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'registeredAt'),
  withState('page', 'setPage', 0),
  withHandlers({
    handleRedirectOpen: props => path => {
      // console.log(props);
      // console.log(path);
      // window.open(path, '_blank');
      props.history.push(path);
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    progress,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    shops,
    rowsPerPage,
    order,
    orderBy,
    handleRedirectOpen,
    handleChangeRowsPerPage,
    handleRequestSort
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const shopRedirectAction = shopId =>
      handleRedirectOpen(`/shops?shopId=${shopId}`);
    const menuRedirectAction = shopId =>
      handleRedirectOpen(`/gochi_menus?shopId=${shopId}`);
    const identityRedirectAction = shopId =>
      handleRedirectOpen(`/identities?shopId=${shopId}`);

    const removeStripeAction = params => {
      progress.updateOpenProgress(true);
      removeStripShopData({ shopId: params.id })
        .then(async data => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (data.data.code === 200) {
            alert('Stripe紐付けが解除されました。');
            handleChangePage(null, 1, rowsPerPage.textContent);
          } else {
            alert('Stripe紐付けがまだ解除されません。');
          }
        })
        .catch(() => {
          alert('Stripe紐付けがまだ解除されません。');
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <ReleaseTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <ReleaseTableBody
              shops={shops}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              shopRedirectAction={shopRedirectAction}
              menuRedirectAction={menuRedirectAction}
              identityRedirectAction={identityRedirectAction}
              removeStripeAction={removeStripeAction}
              order={order}
              orderBy={orderBy}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={shops}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
